module.exports = __webpack_public_path__ + "img/paper_bobocoin.gm.9c47f95.png";